/**  Статус запроса */
export enum EventCode {

  /// Логин.
  Login = "LOGIN",

  /// Регистрация.
  Registration = "REGISTRATION",

  /// Восстановление пароля.
  ResetPassword = "RESET_PASSWORD",

  /// Восстановление логина.
  ResetLogin = "RESET_LOGIN",

  /// Смена пароля.
  ChangePassword = "CHANGE_PASSWORD",

  /// Смена Пин-кода устройства.
  ChangePinCode = "СHANGE_PIN",

  /// Смена логина.
  ChangeLogin = "CHANGE_LOGIN",

  /// Заявка.
  Request = "REQUEST"
}
